import { TrackingStage } from '@/config/tracking';
import { CallToActionEnum } from '@/graphql/types';

const CONTACT = 'contact';
const COMPLETE_FLYER_FORM = 'complete_flyer_form';
const LEARN_MORE = 'learn_more';

export default function getFeatureLinkTracking(featureLinkType: CallToActionEnum) {
  const contactLinks = [
    CallToActionEnum.Call,
    CallToActionEnum.Email,
    CallToActionEnum.Sms,
    CallToActionEnum.Map,
  ];
  if (contactLinks.includes(featureLinkType)) {
    return {
      stage: TrackingStage.commitment,
      event: CONTACT,
      event_detail: `${CONTACT}_${featureLinkType}`,
    };
  }

  if (featureLinkType === CallToActionEnum.LearnMore) {
    return {
      stage: TrackingStage.consideration,
      event: LEARN_MORE,
      event_detail: LEARN_MORE,
    };
  }

  return {
    stage: TrackingStage.commitment,
    event: COMPLETE_FLYER_FORM,
    event_detail: `${COMPLETE_FLYER_FORM}_${featureLinkType}`,
  };
}
